import React from "react";
import { useTheme } from "styled-components";

import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import { StyledStory } from "./styles";
import messages from "./messages";

const Story = ({ isNativeApp = false }) => {
    const { c } = useTheme();
    return (
        <StyledStory>
            {!isNativeApp && (
                <h2>
                    <FormattedMessage {...messages.h2} />
                </h2>
            )}
            <p style={{ ...(isNativeApp && {
                paddingTop: 12,
            })}}>
                <FormattedHTMLMessage {...messages.p} values={{ icon: "", br: "", shy: "&shy;" }} />
            </p>
        </StyledStory>
    );
}

export default Story;
